import { combineReducers } from 'redux';
// import { reducer as form } from 'redux-form';

import tableQuotations from 'Redux/reducers/tableQuotations';
import globalQuotation from 'Redux/reducers/globalQuotation';
import initialData from 'Redux/reducers/initialData';
import utilitiesReducer from 'Redux/reducers/utilitiesReducer';
import comparationQuotationReducer from 'Redux/reducers/comparationQuotationReducer';
import softsegurosVendedores from 'Redux/reducers/softsegurosVendedores';
import sendEmail from 'Redux/reducers/sendEmailReducer';
import sendWhatsApp from 'Redux/reducers/sendWhatsAppReducer';
import globalsReducer from 'Redux/globals';

export default combineReducers({
  initialData,
  globalQuotation,
  tableQuotations,
  utilities: utilitiesReducer,
  comparationQuotation: comparationQuotationReducer,
  softsegurosVendedores,
  sendEmailQuotation: sendEmail,
  sendWhatsAppQuotation: sendWhatsApp,
  globals: globalsReducer,
});
